import React, { useState, useEffect } from 'react';
import { Card, Switch, message, Typography, Alert } from 'antd';
import axios from 'axios';

const { Text } = Typography;
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const SystemSettingsPanel = () => {
  const [membershipEnabled, setMembershipEnabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios.get('/settings/membership', { headers: authHeaders() })
      .then((r) => { if (r.data.success) setMembershipEnabled(r.data.membershipEnabled); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const onToggle = async (checked) => {
    setSaving(true);
    try {
      const r = await axios.put('/settings/membership', { enabled: checked }, { headers: authHeaders() });
      if (r.data.success) {
        setMembershipEnabled(r.data.membershipEnabled);
        message.success(checked ? '已开启会员付费模式' : '已关闭会员付费：所有账号免费使用全部模块');
      } else {
        message.error(r.data.message || '保存失败');
      }
    } catch (e) {
      message.error('保存失败');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card title="系统设置">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 240 }}>
          <div style={{ fontSize: 16, fontWeight: 600 }}>会员付费模式</div>
          <Text type="secondary" style={{ fontSize: 13 }}>
            开启 = 正常会员模式（高级模块、网盘需会员）；<br />
            关闭 = 所有账号免费使用全部模块、不提示升级（供 App / 小程序审核期使用，审核通过后再开回）。
          </Text>
        </div>
        <Switch
          checked={membershipEnabled}
          loading={loading || saving}
          onChange={onToggle}
          checkedChildren="会员模式"
          unCheckedChildren="全免费"
        />
      </div>
      {!membershipEnabled && (
        <Alert
          style={{ marginTop: 16 }}
          type="warning"
          showIcon
          message="当前为「全免费」模式：所有账号可免费使用全部模块与网盘。审核通过后请记得切回「会员模式」。"
        />
      )}
    </Card>
  );
};

export default SystemSettingsPanel;
